<template>

    <m-edit1/>

    <m-single-product-201 v-bind='{...{"productLink":null,"relatedProducts":true,"productCardName":"mProductCard207_price","relatedCourse":false,"galleryFullSlider":false,"productAuthor":false,"showSpecifiedFeature":"","showVariationProductImage":false,"mapFeatureName":null,"variationProductComponent":"VariationProduct"},...{}}' :style='""' class="my-3 container" >
                <template #default>   <m-span v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>   </template>
                </m-span></template>
                </m-single-product-201>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mSingleProduct201 from '@moeinmdn/miw-alpha-components/src/package/Product/Single/SingleProduct201'; import mSpan from '@moeinmdn/miw-alpha-components/src/package/Tags/Span';

export default {
    name: 'HomeView',
    components: {mEdit1, mSingleProduct201,mSpan },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
